import {$window, $body, Breakpoints} from '../Constants';

/**
 * Helper Utility Class
 */
class HelperUtility {
	atBreakpoint(breakpoint) {
		let ret = false;

		if(typeof breakpoint !== "undefined") {
			if(this.isNumeric(breakpoint)) {
				if($window.width() >= breakpoint) {
					ret = true;
				}
			}else if(breakpoint in Breakpoints) {
				if($window.width() >= Breakpoints[breakpoint]) {
					ret = true;
				}
			}
		}

		return ret;
	}

	isNumeric(n) {
		return !isNaN(parseFloat(n)) && isFinite(n);
	}

	hasOneOfClasses($element, classes) {
		for(let i = 0; i < classes.length; i++) {
			if($element.hasClass(classes[i])) {
				return i;
			}
		}

		return -1;
	}
}

export default (new HelperUtility);